// reset redirecting flag in case back button was clicked in the browser
window.addEventListener('pageshow', function () { window.isBeingRedirected = false; });

(($, w) => {
    const gtmImpressionsChunkSize = 30;
    const assetId = 'gtm-ga4-prod-list';

    let userInfo = null;
    if (w.umwAssets && w.umwAssets[assetId] && w.umwAssets[assetId].length) {
        userInfo = w.umwAssets[assetId][0];
    }

    w.PubSub.subscribe('externaltracking.product.listview', (_, productImpressions) => {
        if (productImpressions && productImpressions.items && productImpressions.items.length > 0) {
            processProductList(productImpressions);
        }
    });

    function processProductList(productList) {
        const listName = productList.listName || document.title;
        const allProducts = productList.items;
        const totalProductsCount = allProducts.length;
        var $allProductLinks = $(); 
        var idx = 0, chunkIdx = 0;
        const utils = new GtmUtils();
        const currencyCode = utils.getCurrencyCode(productList);

        while (idx < totalProductsCount) {
            const positionShift = chunkIdx * gtmImpressionsChunkSize;

            const products = allProducts.slice(idx, idx += gtmImpressionsChunkSize);
            const gtmProducts = [];

            const itemListId = productList.listType.replace(/\s+/g, '_').toLowerCase();
            const itemListName = productList.listType;

            for (var i = 0, l = products.length; i < l; i++) {
                const prod = products[i];
                const positionInList = positionShift + i + 1;
                const gtmProd = utils.convertToGtmGa4Product(prod,
                    {
                        'currency': currencyCode,
                        'item_list_id': itemListId,
                        'item_list_name': itemListName,
                        'list_name': listName,
                        'index': positionInList
                    });
                if (gtmProd) {
                    gtmProducts.push(gtmProd);

                    if (prod.$links) {
                        prod.$links.data('gtm-product', gtmProd);
                        prod.$links.data('listname', listName);
                        prod.$links.data('currencycode', currencyCode);

                        $allProductLinks = $allProductLinks.add(prod.$links);
                    }
                }
            }

            const viewItemListEvent = {
                'event': 'view_item_list',
                'ecommerce': {
                    'items': gtmProducts,
                    'item_list_id': itemListId,
                    'item_list_name': itemListName,
                }
            };

            if (userInfo) {
                viewItemListEvent.user = userInfo;
            }

            w.dataLayer.push({ ecommerce: null });  // Clear the previous ecommerce object.
            w.dataLayer.push(viewItemListEvent);

            ++chunkIdx;
        }

        if ($allProductLinks.length > 0) {
            $allProductLinks.on('click', function (evt) {
                try {
                    if (w['google_tag_manager']) {
                        var targetUrl = this.href;
                        const $this = $(this);

                        const productClickEvent = {
                            'event': 'select_item',
                            'ecommerce': {
                                'items': [$this.data('gtm-product')]
                            },
                            'eventCallback': function () {
                                if (!w.isBeingRedirected) {
                                    document.location = targetUrl;
                                    w.isBeingRedirected = true;
                                }
                            },
                            'eventTimeout': 1000
                        };

                        w.dataLayer.push({ ecommerce: null });  // Clear the previous ecommerce object.
                        w.dataLayer.push(productClickEvent);

                        evt.preventDefault();
                    }
                } catch (e) {
                    console.error('[GTM]: Failed to push product click event to dataLayer. Reason: ' + e);
                }
            });
        }
    }
})(jQuery, window);